import { Directive } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { ModalHtmlDirective } from './modal-html.directive';

@Directive({
  selector: '[politicallyExposedPersonDirective]'
})

export class PoliticallyExposedPersonDirective extends ModalHtmlDirective {

  constructor(
    protected modal: ModalController
    ) {

    super(modal);

    this.titleKey = 'POLITICALLY_EXPOSED_PERSON';
    this.contentKeys = ['POLITICALLY_EXPOSED_PERSON_TEXT'];

  }

}
